import { t } from "@/i18n-js/instance";
import { Dropdown } from "@circle-react-uikit/Dropdown";

const i18nRoot = "settings.workflows.table.actions";

interface DuplicateProps {
  onClick: () => void;
}

export const Duplicate = ({ onClick }: DuplicateProps) => (
  <Dropdown.ItemWithLink onClick={onClick}>
    {t([i18nRoot, "duplicate"])}
  </Dropdown.ItemWithLink>
);
